import React, { type FC } from 'react'

import styled from '@emotion/styled'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Button,
  Flex,
} from 'mailup-web-components'

import {
  panelConfigColumnsCloseCallback,
  panelConfigColumnsConfirmCallback,
} from 'Pages/RecipientsList/recoil/callbacks/configColumns'
import { panelConfigColumnsCanSaveState } from 'Pages/RecipientsList/recoil/state/configColumns'

const StyledFooter = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 1;
  background-color: #fff;
`

const PanelConfigColumnsFooter: FC = () => {
  const intl = useIntl()

  const handleCancel = useRecoilCallback(panelConfigColumnsCloseCallback, [])

  const handleConfirm = useRecoilCallback(panelConfigColumnsConfirmCallback, [])

  const canConfirm = useRecoilValue(panelConfigColumnsCanSaveState)

  return (
    <StyledFooter>
      <Flex justifyContent="end" padding="16px 32px" gap="8px">
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          data-mu-test="cancel"
          onClick={handleCancel}
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>

        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          data-mu-test="confirm"
          onClick={handleConfirm}
          disabled={!canConfirm}
        >
          {intl.formatMessage({
            id: 'Load.MailupCommon.Save',
          })}
        </Button>
      </Flex>
    </StyledFooter>
  )
}

export default PanelConfigColumnsFooter
